import BootstrapDropdown, {
  DropdownToggle,
  DropdownItem,
} from "@stadium/ui/src/components/bootstrap-dropdown";

import AuthLogin from "@components/auth/buttons/login";
import { InternalButton } from "@sharedComponents/buttons";

import { DROPDOWN_ITEMS } from "@components/swagmagic/profile-dropdown/unauthenticated-button/constants";

import styles from "./main.module.scss";

const WebUnAuthenticatedButton = ({ className = "" }) => {
  const renderDropdownItems = () =>
    DROPDOWN_ITEMS.map(({ btnText, loginOptions = {} }) => (
      <DropdownItem className={styles.dropdownItemV2} key={btnText} as="div">
        <AuthLogin className={styles.authLogin} loginOptions={loginOptions}>
          <InternalButton
            styleType="no-style"
            className={`${styles.loggedOutDropdownButton} ${className}`}
          >
            {btnText}
          </InternalButton>
        </AuthLogin>
      </DropdownItem>
    ));

  return (
    <BootstrapDropdown
      menuClassName={styles.loggedOutDropdown}
      label={
        <DropdownToggle showDropdownIcon={false}>
          <span className={styles.userIcon} />
        </DropdownToggle>
      }
    >
      {renderDropdownItems()}
    </BootstrapDropdown>
  );
};

export default WebUnAuthenticatedButton;
